module.exports = __webpack_public_path__ + "static/WindingWorlds0-9183cebecdfd735abce8d396d2880c99.webp";